import { httpPost } from "lib/http/http";
import { IEIP712 } from "lib/types/IEIP712";

export const getSigningMessage = (
  address: string,
  csrf?: string
): Promise<IEIP712> => {
  const headers = new Headers();
  headers.append("Cookie", `csrf=${csrf}`);
  headers.append("Content-Type", "application/json");
  return httpPost<IEIP712>(
    "api/auth/get_signing_message",
    { userAddress: address, csrf },
    { headers, redirect: "follow" }
  );
};
